import { http } from 'vue'

export default {
  postClientPjFiles (context, params = {}) {
    return http.post('clients_pj_files', params.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/image_upload/actions.js